import { Option } from './option.model';
import { Creator } from './creator.model';

export enum RequestScheduleType {
  ONE_TIME = 'one_time',
  RECURRING = 'recurring',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum ScheduleRecurrenceBy {
  INTERVAL = 'interval',
  MONTHS = 'months',
}

export enum ScheduleRecurrenceMode {
  SPECIFIC = 'specific',
  RELATIVE = 'relative',
}

export interface ScheduleRecurrencePayload {
  type: string;
  interval: number;
  by?: string;
  mode?: ScheduleRecurrenceMode;
  months?: number[];
  days_of_week?: number[];
  days_of_month?: number[];
  relative_option?: number;
}

/** The API sends recurrence enums either as options or as raw string values. */
export type ScheduleRecurrenceOption = Option | string;

export interface ScheduleRecurrenceDetails {
  type: ScheduleRecurrenceOption;
  by?: ScheduleRecurrenceOption | null;
  interval?: number | null;
  mode?: ScheduleRecurrenceOption | null;
  months?: number[] | null;
  relative_option?: number | null;
  days_of_month?: number[] | null;
  days_of_week?: number[] | null;
}

export interface RequestSchedule {
  id: number;
  schedule_type: Option;
  state: Option;
  description: string | null;
  job: Option;
  start_at: string;
  end_at: string | null;
  next_run_at: string;
  recurrence?: ScheduleRecurrenceDetails | null;
  created_by: Creator;
  cancelled_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface RequestScheduleDetails {
  id: number;
  schedule_type: Option;
  start_at: string;
  end_at?: string | null;
  repeat_every?: number | null;
  repeat_days?: string[] | null;
  repeat_on_by_day_of_month?: boolean | null;
  recurrence?: ScheduleRecurrenceDetails | null;
  description?: string | null;
  created_by?: Creator | null;
  state: Option;
}

export interface CreateRequestSchedulePayload {
  start_at: string;
  schedule_type: RequestScheduleType;
  description: string;
  repeat_every?: number;
  end_at?: string;
  repeat_days?: string[];
  repeat_on_by_day_of_month?: boolean;
  recurrence?: ScheduleRecurrencePayload;
}
